document.getElementById('bannerForm').addEventListener('submit', function(event) {
    event.preventDefault();
  
    // Get the current date and time
    var currentDate = new Date();
    var date = currentDate.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    var time = currentDate.toTimeString().split(' ')[0]; // Format: HH:MM:SS
  
    // Set the values in the hidden fields
    document.getElementById('formDate').value = date;
    document.getElementById('formTime').value = time;
  
    var form = document.getElementById('bannerForm');
    var formData = new FormData(form);
    var submitButton = document.getElementById('submitButton');
    var loader = document.getElementById('loader');
  
    // Show loader and disable submit button
    loader.style.display = 'inline-block';
    submitButton.disabled = true;
  
    fetch(form.action, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    })
    .then(response => response.text())
    .then(result => {
      // Hide loader, enable button, and display thank-you message
      loader.style.display = 'none';
      submitButton.disabled = false;
      document.getElementById('bannerForm').style.display = 'none';
      document.getElementById('thankYouMessage').style.display = 'flex';
      
      var currentUrl = window.location.href;
      var newUrl = currentUrl + (currentUrl.includes('?') ? '&' : '?') + 'request_submitted=true';
      window.history.replaceState(null, null, newUrl);
    })
    .catch(error => {
      console.error('Error:', error);
      loader.style.display = 'none';
      submitButton.disabled = false;
    });
  });
  